import { render, staticRenderFns } from "./PassengerImportMapper.vue?vue&type=template&id=40c17f03"
import script from "./PassengerImportMapper.vue?vue&type=script&lang=ts"
export * from "./PassengerImportMapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports